import React, {useState} from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import {AnimatedSwitch} from 'react-router-transition';
import { useMediaQuery } from '@material-ui/core';
import { PersistGate } from 'redux-persist/integration/react'
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';


import { Provider } from 'react-redux';
import {store, persistor} from './redux/store';

import { createMuiTheme, ThemeProvider, makeStyles} from '@material-ui/core/styles';
import { drawerWidth } from './utils/mainStyle';

import styles from './utils/mainStyle';

import Routes from './Routes';

import theme from './theme/theme';

//import "./assets/material-style.css"
import './StyleMe.css';

import MainHeader from './components/header/MainHeader';

import SubHeader from './components/header/SubHeader';

import Footer from './components/footer/Footer';

import Navigator from './components/navigator/Navigator';
import CommonNavigator from './components/navigator/CommonNavigator';

const useStyles = makeStyles(theme => ({
    ...styles,
})
)

//Love fom Olaide-E.O



function App() {
   const classes = useStyles();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });

  const [openSidebar, setOpenSidebar] = useState(false);
  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };
  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };
  const shouldOpenSidebar = isDesktop ? true : openSidebar;
    return (

    <ThemeProvider theme={theme}>
        <Provider store={store}>
                <PersistGate 
                      loading={(
                        <Backdrop open={true}>
                            <CircularProgress color="inherit" />
                        </Backdrop>
                      )} 
                      persistor={persistor} >

                <Router>
                   <div className={classes.root}>
                      <CommonNavigator 
                       PaperProps={{ style: { width: drawerWidth } }}
                          handleSidebarClose={handleSidebarClose}
                          open={shouldOpenSidebar}
                          variant={isDesktop ? 'persistent' : 'temporary'}
                       component={Navigator} />
                                            
                    <div className={classes.app}>

                       <MainHeader onSidebarOpen={handleSidebarOpen}/>
                       <SubHeader />
               
                        <Routes />
                      
                      <footer className={classes.foot}>
                        <Footer/>
                      </footer>

                     </div>
                   </div>
                </Router>
          </PersistGate>
        </Provider>
    </ThemeProvider>
  );
}


export default App;




/*
 <AnimatedSwitch
                atEnter={{opacity: 0}}
                atLeave={{opacity: 0}}
                atActive={{opacity: 1}}
                className="switch-wrapper"
                location={location}
              >

</AnimatedSwitch>
*/